import InvoicesPage from "./InvoicesPage";

export default InvoicesPage;
